import { render } from "./NewsSort.vue?vue&type=template&id=56627d92&scoped=true"
import script from "./NewsSort.vue?vue&type=script&lang=js"
export * from "./NewsSort.vue?vue&type=script&lang=js"

import "./NewsSort.vue?vue&type=style&index=0&id=56627d92&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56627d92"]])

export default __exports__